/**
 * Created by ZD on 2021/5/9.
 */

// 打包后静态资源根路径（用于 webpack 生成 dist/index.html 中的静态资源引用路径）
// 改为不走 /admin 后，建议使用空字符串，让产物在本地 `file://` 或站点根目录下都能正常加载。
const publicPath = '';
// const publicPath = '/admin' // 如果你需要部署到站点的 /admin 子目录


// const baseUrl = "http://192.168.0.111:50777/"
// const baseUrl = "http://49.232.191.230:50456"; //cn环境
// 开发环境用 dev.env 的 API_BASE_URL，生产环境用 prod.env 的 API_BASE_URL
const baseUrl = (typeof process !== 'undefined' && process.env && process.env.API_BASE_URL) ? process.env.API_BASE_URL : "https://kxht.naolingtong.com";

// const baseUrl_media = "http://192.168.0.111:50777/"
// const baseUrl_media = "http://49.232.191.230:50456"; //cn环境
const baseUrl_media = baseUrl;

module.exports = {
  publicPath:publicPath,
  baseUrl:baseUrl,
  baseUrl_media:baseUrl_media
}



//////////////////
// WEBPACK FOOTER
// ./global.js
// module id = qO5Z
// module chunks = 1